export default __webpack_public_path__ + "/dist/images/default_image.jpg";